import * as echarts from 'echarts/core'
import { BarChart, LineChart } from 'echarts/charts'
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

// Só o que os dashboards usam: importar 'echarts' inteiro somaria quase 1 MB ao pacote do portal.
echarts.use([BarChart, LineChart, GridComponent, LegendComponent, TooltipComponent, CanvasRenderer])

export { echarts }

export type EChartOption = echarts.EChartsCoreOption

/**
 * Desenha o gráfico fora da tela e devolve a imagem PNG (data URL), para o PDF. Mesma configuração da tela, sem
 * animação, em fundo branco e com o dobro de pixels para sair nítido na impressão.
 */
export function graficoComoImagem(option: EChartOption, largura: number, altura: number): string {
    const div = document.createElement('div')
    div.style.cssText = `position:fixed;left:-10000px;top:0;width:${largura}px;height:${altura}px`
    document.body.appendChild(div)
    const chart = echarts.init(div, undefined, { renderer: 'canvas', width: largura, height: altura })
    try {
        chart.setOption({ ...option, animation: false })
        return chart.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' })
    } finally {
        chart.dispose()
        div.remove()
    }
}
